import { ExpBackStatusUpdateType, ExpressBackStatuses } from "./ExpressBackType";
import { Modal } from '../../components';
import { api } from "../../config/api";
import { useTranslation,useSelector,useRequest } from "../../hooks/";
import {Form,message, Select} from 'antd';
import { useState } from "react";

export const UpdateStatus: React.FC<ExpBackStatusUpdateType> = ({setVisible, expBacks}) => {

    // const [parentId1, setParentId1] = useState(parentId || 0);
    const [enable, setEnable] = useState(true);
    const t = useTranslation();
    const [form] = Form.useForm();
    const setting = useSelector(state => state.setting);
    const {request} = useRequest();

    const handleClose = () => {
        setEnable(false);
        setTimeout(() => {
            setVisible(false);
        }, 500);
    }

    const onFinishFailed = () => {
        message.warning({
            content: t('请确认数据正确后在提交'),
        });
    };

    const onFinish = (values) => {
        // console.log(values);
        let ids = expBacks.map(e => e.id).join(",");
        let status = values.status;

        // console.log(data);
        let url = api.expBack.status;
        
        let update = async() => {
            let result = await request.post(url, "codes="+ids+"&status="+status+"&type=0");
            if(result.status){
                message.success(t(result.msg));
                expBacks.forEach(e => e.status = status);
                handleClose();
            }else{
                message.warning(t(result.msg));
            }
        }

        update();
    };
    
    const formHtml = (
        <div className="edit-form-wrap">
            <Form form={form} labelCol={{span: 6}} wrapperCol={{span:18}} 
                size={setting.size}
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
            >   
                <Form.Item
                label={t('状态')}
                name="status"
                rules={[{ required: true, message:  t("状态不能为空")}]}
                >
                    <Select allowClear>
                        {ExpressBackStatuses.map(s => 
                            (<Select.Option key={s.value} value={s.value}>{t(s.label)}</Select.Option>)
                        )}
                    </Select>
                </Form.Item>
            </Form>
        </div>
    );

    let title =t('更新退件状态')
        
    return (
        <Modal visible={enable}
            title={title}
            onOk={()=>{form.submit()}}
            onCancel={()=>handleClose()}
            afterClose={()=>handleClose()}
        >
            {formHtml}
        </Modal>
    )

}